module.exports = __webpack_public_path__ + "img/1516858196.a6f6c9f8.jpg";